import { Injectable, OnDestroy } from '@angular/core';
import { AbstractCRUDService } from '@campaign-portal/components-library';
import { EntityField, InputComplexType, InputType } from '@campaign-portal/namespace/common/entityField';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class HistoryLogsFieldsService implements AbstractCRUDService, OnDestroy {

	readonly entity = '';
	readonly title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);

	readonly id: EntityField = {
		id: 0,
		name: 'history_logs.id',
		variable: 'ID',
		type: InputType.TEXT,
		filterType: FilterType.LIKE,
		required: true
	};
	readonly actionId: EntityField = {
		id: 1,
		name: 'history_logs.action_id',
		variable: 'ActionID',
		type: InputType.TEXT,
		filterType: FilterType.LIKE,
		required: true
	};
	readonly tableName: EntityField = {
		id: 1,
		name: 'history_logs.table_name',
		variable: 'TableName',
		type: InputType.TEXT,
		filterType: FilterType.EXACT,
		required: false
	};
	readonly actionType: EntityField = {
		id: 2,
		name: 'history_logs.action_type',
		variable: 'ActionType',
		type: InputType.TEXT,
		filterType: FilterType.EXACT,
		required: false
	};
	readonly recordCount: EntityField = {
		id: 3,
		name: 'history_logs.record_count',
		variable: 'RecordCount',
		type: InputComplexType.RANGE,
		filterType: FilterType.BETWEEN,
		required: false
	};
	readonly actionTime: EntityField = {
		id: 3,
		name: 'history_logs.action_time',
		variable: 'ActionTime',
		type: InputComplexType.DATE_RANGE,
		filterType: FilterType.BETWEEN,
		required: false
	};
	readonly user: EntityField = {
		id: 3,
		name: 'history_logs.user',
		variable: 'UserID',
		type: InputComplexType.SELECT,
		filterType: FilterType.LIKE,
		required: false,
		data: []
	};

	readonly headers: EntityField[] = [
		this.id,
		this.actionId,
		this.tableName,
		this.actionType,
		this.recordCount,
		this.actionTime,
		this.user
	];

	constructor() {
	}

	ngOnDestroy(): void {
		this.loading$.complete();
	}

	read(): Observable<ReadResponse<EntityField[]>> {
		return of({
			Success: true,
			Total: this.headers.length,
			Data: this.headers
		});

	}

	create(): Observable<void> {
		return of();
	}

	update(): Observable<void> {
		return of();
	}

	delete(): Observable<void> {
		return of();
	}
}
